module.exports = __webpack_public_path__ + "static/media/cate-art.75be97dd.png";